import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi/vue';
import { mainnet, bsc, polygon } from 'viem/chains';
import { createStorage, reconnect } from '@wagmi/core';

// 1. Define constants
const projectId = 'a5825827a80f6c5cc3059bb2b21c5417';

// 2. Create wagmiConfig
const metadata = {
  name: 'Web3Modal',
  description: 'Web3Modal Example',
  url: 'https://web3modal.com', // origin must match your domain & subdomain
  icons: ['https://avatars.githubusercontent.com/u/37784886']
};

const chains = [mainnet, bsc, polygon];
export const wagmiConfig = defaultWagmiConfig({
  chains,
  projectId,
  metadata,
  storage: createStorage({ storage: window.localStorage }),
  enableCoinbase: false,
  enableInjected: false,
  auth: {
    email: false, // default to true
    showWallets: true,
    walletFeatures: true
  }
});

reconnect(wagmiConfig);

// 3. Create modal
createWeb3Modal({
  wagmiConfig,
  projectId,
  themeMode: 'dark',
  enableOnramp: true,
  enableSwaps: false,
  enableAnalytics: true
});
